// Deterministic avatar colors mirror the mockup's AV_COLORS palette
// (breadstack-loyalty.html line 518). Kept as literals because there is no
// equivalent multi-hue palette token in @pantry/ui.
const AVATAR_PALETTE = [
  '#2563EB',
  '#7C3AED',
  '#0F766E',
  '#B45309',
  '#DC2626',
  '#0E7490',
  '#9333EA',
  '#059669',
] as const

export const initialsFromName = (name: string): string => {
  const trimmed = name.trim()
  if (!trimmed) return '?'
  const parts = trimmed.split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export const fullName = (firstName: string, lastName: string): string =>
  `${firstName.trim()} ${lastName.trim()}`.trim()

export const avatarColorFromName = (name: string): string => {
  const safe = name.trim() || '?'
  const code = safe.charCodeAt(0)
  return AVATAR_PALETTE[code % AVATAR_PALETTE.length]
}
